var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1183 8.47058H18.363C19.6195 8.47058 20.2407 9.99529 19.3513 10.8847L12.8713 17.3647C12.3207 17.9153 11.4313 17.9153 10.8807 17.3647L4.40067 10.8847C3.51126 9.99529 4.14655 8.47058 5.40302 8.47058H7.64773V1.41176C7.64773 0.635294 8.28302 0 9.05949 0H14.7065C15.483 0 16.1183 0.635294 16.1183 1.41176V8.47058ZM3.41176 24C2.63529 24 2 23.3647 2 22.5882C2 21.8118 2.63529 21.1765 3.41176 21.1765H20.3529C21.1294 21.1765 21.7647 21.8118 21.7647 22.5882C21.7647 23.3647 21.1294 24 20.3529 24H3.41176Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.53f395e1.svg";
export { ForwardRef as ReactComponent };